export default __webpack_public_path__ + "static/media/todo-dia-off.6aba8e27.svg";